import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CwpNgFrameworkModule } from '@blk/cwp-ng-framework';
import { DzSelectModule } from '@blk/daisy/combinations/dropdown';
import { DzNotificationsModule } from '@blk/daisy/combinations/notifications';
import { DzTooltipInjectorModule, DzTooltipModule } from '@blk/daisy/combinations/on-screen-help';
import { DzIconModule } from '@blk/daisy/core/icon';
import { DzButtonModule } from '@blk/daisy/elements/buttons';
import { DzModalModule } from '@blk/daisy/modules/modals';
import { AnalyticsModule } from '@ddt-web/analytics';
import { DataServiceModule } from '@ddt-web/data-service';
import { DisclosureModule } from '@ddt-web/disclosure';
import { GenericDirectivesModule } from '@ddt-web/generic-utils';
import { faInfoCircle, faMinus, faPlus } from '@fortawesome/free-solid-svg-icons';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

import { ModelAllocationChartModule } from '../model-allocation-chart';
import { ModelsSliderModule } from '../models-slider';
import { AddToCompareModelComponent } from './add-to-compare-model/add-to-compare-model.component';
import { MiniCompareDataTableComponent } from './mini-compare-data-table/mini-compare-data-table.component';
import { MiniCompareDialogComponent } from './mini-compare-dialog.component';
import { MiniCompareDropdownComponent } from './mini-compare-dropdown/mini-compare-dropdown.component';

@NgModule({
	declarations: [MiniCompareDialogComponent, MiniCompareDropdownComponent, MiniCompareDataTableComponent, AddToCompareModelComponent],
	imports: [
		AnalyticsModule,
		CommonModule,
		CwpNgFrameworkModule,
		DzModalModule,
		DzButtonModule,
		ModelsSliderModule,
		DataServiceModule,
		DzSelectModule,
		DzIconModule.withIcons(faInfoCircle, faPlus, faMinus),
		DzTooltipInjectorModule,
		DzNotificationsModule,
		DzTooltipModule,
		DisclosureModule,
		ModelAllocationChartModule,
		NgxSkeletonLoaderModule,
		GenericDirectivesModule
	]
})
export class MiniCompareDialogModule { }
